import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LandingPageComponent} from './components/landing-page/landing-page.component';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {SchoolsComponent} from './components/schools/schools.component';
import {RegisterComponent} from './components/register/register.component';
import {SportsComponent} from './components/sports/sports.component';
import {AccountManagementComponent} from './components/account-management/account-management.component';
import {WatchComponent} from './components/watch/watch.component';
import {DeactivateGuardService} from './guards/can-deactivate.guard';
import { AngularFireAuthGuard, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {FaqComponent} from './components/faq/faq.component';
import {AdminComponent} from './components/admin/admin.component';
import {DeviceRegisterComponent} from './components/device-register/device-register.component';
import {GiftPageComponent} from './components/gift-page/gift-page.component';

const adminOnly = () => hasCustomClaim('admin');
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToItems = () => redirectLoggedInTo(['live']);
const belongsToAccount = (next) => hasCustomClaim(`account-${next.params.id}`);

const routes: Routes = [
  { path: '', component: LandingPageComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectLoggedInToItems, showSponsor: true }},
  { path: 'account', component: AccountManagementComponent, canActivate: [AngularFireAuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectLoggedInToItems }},
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectLoggedInToItems }},
  { path: 'activate', component: DeviceRegisterComponent},
  { path: 'admin', component: AdminComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'categories/schools', component: SchoolsComponent },
  { path: 'categories/sports', component: SportsComponent },
  { path: 'live', component: HomeComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'watch/:id', component: WatchComponent, canDeactivate: [DeactivateGuardService] },
  { path: 'gift', component: GiftPageComponent},
  { path: 'stream', redirectTo: 'watch/2F3wTjs5NkTz9XvuMeQZXT', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
